import { render, staticRenderFns } from "./frontpage.vue?vue&type=template&id=b3fb1d9c&lang=pug"
import script from "./frontpage.vue?vue&type=script&lang=js"
export * from "./frontpage.vue?vue&type=script&lang=js"
import style0 from "./frontpage.vue?vue&type=style&index=0&id=b3fb1d9c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports